var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagosc"},[(_vm.sesion)?_c('Menu',{attrs:{"url":_vm.url,"sesion":_vm.sesion}}):_vm._e(),_vm._v(" "),(_vm.sesion)?_c('Submenu',{attrs:{"url":_vm.url}}):_vm._e(),_vm._v(" "),_c('PagosC',{staticClass:"mt-5",attrs:{"url":_vm.url}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8ed4ed2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Pagos/Pagos.vue
// module id = null
// module chunks = 